var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages-home"},[_c('carousel',{attrs:{"active_banner":_vm.active_banner}}),_c('div',{staticClass:"content"},[_c('panel',{attrs:{"title":"积分当钱花","info":_vm.scorePay,"jingle":"以下场景消费用积分结账"}}),_c('panel',{attrs:{"title":"消费送积分","info":_vm.mallLst,"jingle":"购物免费·轻松便捷"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }